import { render, staticRenderFns } from "./XrUpgradeDialog.vue?vue&type=template&id=5f5baaaa"
import script from "./XrUpgradeDialog.vue?vue&type=script&lang=js"
export * from "./XrUpgradeDialog.vue?vue&type=script&lang=js"
import style0 from "./XrUpgradeDialog.vue?vue&type=style&index=0&id=5f5baaaa&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5baaaa')) {
      api.createRecord('5f5baaaa', component.options)
    } else {
      api.reload('5f5baaaa', component.options)
    }
    module.hot.accept("./XrUpgradeDialog.vue?vue&type=template&id=5f5baaaa", function () {
      api.rerender('5f5baaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XrUpgradeDialog.vue"
export default component.exports